import React from "react";
import { Field, FieldRenderProps } from "react-final-form";
import DateInput from "../controls/DateInput";
import InfoBox from "../boxes/InfoBox";
import SubmitError from "./SubmitError"
import { fieldClass, identity } from "../../utils/form";

interface Props {
  className?: string;
  disabled?: boolean;
  i18nKey?: string;
  i18nTip?: string
  id?: string;
  min?: string;
  name: string;
}

const DateField = (props: Props): JSX.Element => {
  return (
    <Field
      {...props}
      parse={identity}
      type="date"
      render={(renderProps: FieldRenderProps<number | string>): React.ReactNode => {
        const { className, disabled, i18nKey, i18nTip, id, input, meta, min } = renderProps
        return (
          <div className={fieldClass(className, !!meta.submitError)}>
            <DateInput i18key={i18nKey} input={{...input, disabled, id, min}}/>
            <SubmitError errors={meta.submitError}/>
            {i18nTip && <InfoBox i18nKey={i18nTip}/>}
          </div>
        )
      }}
    />
  )
}

export default DateField
